import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const areaApi = createApi({
  reducerPath: "areaApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://nodejs-bin-it-to-win-it.vercel.app/api/v1",
  }),
  // keepUnusedDataFor: 120,
  tagTypes: ["Area"],
  endpoints: (builder) => ({
    //CRUD
    getAllAreas: builder.query({
      query: () => "/areas",
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ type: "Area", id })),
              { type: "Area", id: "LIST" },
            ]
          : [{ type: "Area", id: "LIST" }],
    }),
    getArea: builder.query({
      query: (area) => `/areas?keyword=${area}`,
      providesTags: (result, error, id) => {
        return [
          { type: "Area", id },
          { type: "Area", id: "LIST" },
        ];
      },
    }),
    createArea: builder.mutation({
      query: (area) => ({
        url: "/areas",
        method: "POST",
        body: area,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
      invalidatesTags: [
        {
          type: "Area",
          id: "LIST",
        },
      ],
    }),
    updateArea: builder.mutation({
      query: ({ id, area }) => ({
        url: `/areas/${id}`,
        method: "PATCH",
        body: area,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
      invalidatesTags: [
        {
          type: "Area",
          id: "LIST",
        },
      ],
    }),
    deleteArea: builder.mutation({
      query: (id) => ({
        url: `/areas/${id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
      invalidatesTags: (result, error, id) => {
        return [
          { type: "Area", id },
          { type: "Area", id: "LIST" },
        ];
      },
    }),
  }),
});
// Dynamic hook
export const {
  useGetAllAreasQuery,
  useGetAreaQuery,
  useCreateAreaMutation,
  useUpdateAreaMutation,
  useDeleteAreaMutation,
} = areaApi;
